
import {

  DecoratorNode,
} from 'lexical';
import PollComponent from './PollComponent';


function createUID() {
  return Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substring(0, 5);
}

export function createPollOption(text = '') {
  return {
    text,
    uid: createUID(),
    votes: [],
  };
}

function cloneOption(option, text, votes) {
  return {
    text,
    uid: option.uid,
    votes: votes || Array.from(option.votes),
  };
}


function parseOptions(json) {
  const options = [];
  if (Array.isArray(json)) {
    for (const row of json) {
      if (
        row &&
        typeof row.text === 'string' &&
        typeof row.uid === 'string' &&
        Array.isArray(row.votes) &&
        row.votes.every((v) => typeof v === 'number')
      ) {
        options.push(row);
      }
    }
  }
  return options;
}

export class PollNode extends DecoratorNode {
  __question;
  __options;

  static getType() {
    return 'poll';
  }

  static clone(node) {
    return new PollNode(node.__question, Array.from(node.__options), node.__key);
  }

  static importJSON(serializedNode) {
    const node = $createPollNode(
      serializedNode.question,
      parseOptions(serializedNode.options),
    );
    return node;
  }

  constructor(question, options, key) {
    super(key);
    this.__question = question;
    this.__options = options;
  }

  exportJSON() {
    return {
      options: this.__options,
      question: this.__question,
      type: 'poll',
      version: 1,
    };
  }

  addOption(option) {
    const self = this.getWritable();
    const options = Array.from(self.__options);
    options.push(option);
    self.__options = options;
  }

  deleteOption(option) {
    const self = this.getWritable();
    const options = Array.from(self.__options);
    const index = options.indexOf(option);
    if (index === -1) {
      return;
    }
    options.splice(index, 1);
    self.__options = options;
  }

  setOptionText(option, text) {
    const self = this.getWritable();
    const clonedOption = cloneOption(option, text);
    const options = Array.from(self.__options);
    const index = options.indexOf(option);
    if (index === -1) {
      return;
    }
    options[index] = clonedOption;
    self.__options = options;
  }

  toggleVote(option, clientID) {
    const self = this.getWritable();
    const votes = option.votes;
    const votesClone = Array.from(votes);
    const index = votes.indexOf(clientID);
    if (index === -1) {
      votesClone.push(clientID);
    } else {
      votesClone.splice(index, 1);
    }
    const clonedOption = cloneOption(option, option.text, votesClone);
    const options = Array.from(self.__options);
    const optionIndex = options.indexOf(option);
    if (optionIndex === -1) {
      return;
    }
    options[optionIndex] = clonedOption;
    self.__options = options;
  }

  createDOM() {
    const elem = document.createElement('span');
    elem.setAttribute('data-lexical-poll-question', this.__question);
    elem.setAttribute('data-lexical-poll-options', JSON.stringify(this.__options));
    return elem;
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return (
      <PollComponent
        question={this.__question}
        options={this.__options}
        nodeKey={this.__key}
      />
    );
  }
}

export function $createPollNode(question, options) {
  return new PollNode(question, options);
}

export function $isPollNode(node) {
  return node instanceof PollNode;
}
